// extracted by mini-css-extract-plugin
module.exports = {"chipStyle":"MerchandiseVariantsChipsStyle_chipStyle__2oq2-","variantWrapper":"MerchandiseVariantsChipsStyle_variantWrapper__3I6-2"};